import company from "@helio-shared/company.json";

export type CompanyAddress = {
  line1: string;
  city: string;
  postcode: string;
  country: string;
  full: string;
  short: string;
};

export type CompanyProfile = {
  legalName: string;
  tradingName: string;
  tradingNote: string;
  scoreName: string;
  confidenceName: string;
  companyNumber: string;
  address: CompanyAddress;
  supportEmail: string;
  supportPhone: string;
  websiteUrl: string;
  financeDisclosure: string;
};

function hostFromUrl(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return url.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  }
}

export const COMPANY = company as CompanyProfile;

export const LEGAL_NAME = COMPANY.legalName;
export const TRADING_NAME = COMPANY.tradingName;
export const SCORE_NAME = COMPANY.scoreName;
export const CONFIDENCE_NAME = COMPANY.confidenceName;
export const BRAIN_NAME = `${COMPANY.tradingName}Brain`;
export const TEAM_NAME = `The ${COMPANY.tradingName} team`;
export const COMPANY_NUMBER = COMPANY.companyNumber;
export const COMPANY_ADDRESS = COMPANY.address;
export const SUPPORT_EMAIL = COMPANY.supportEmail;
export const SUPPORT_PHONE = COMPANY.supportPhone;

/** Convert a UK display number into an E.164 `tel:` href. */
export function toTelHref(phone: string): string {
  const trimmed = phone.trim();
  if (!trimmed) return "tel:";
  const digits = trimmed.replace(/\D/g, "");
  if (trimmed.startsWith("+")) return `tel:+${digits}`;
  if (trimmed.startsWith("00")) return `tel:+${digits.slice(2)}`;
  if (digits.startsWith("0")) return `tel:+44${digits.slice(1)}`;
  return `tel:${digits}`;
}

export const SUPPORT_PHONE_TEL = toTelHref(SUPPORT_PHONE);

/** Canonical public site URL with no trailing slash. */
export const WEBSITE_URL = COMPANY.websiteUrl.replace(/\/$/, "");
/** Hostname for display (e.g. powlo.co). */
export const WEBSITE = hostFromUrl(WEBSITE_URL);

export const FOOTER_DISCLAIMER = `${COMPANY.legalName} · Company No. ${COMPANY.companyNumber} · ${COMPANY.address.short}`;
